export enum ETipoFatura {
  CSV = '1',
  PDF = '2'
}
